export default __webpack_public_path__ + "static/media/ic_camera_v2.89634bda.svg";